import React from 'react';

export const QuestionIconSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.8595 20.7418C15.387 21.562 13.7246 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 13.7246 21.562 15.387 20.7418 16.8595L21.0947 21.0947L16.8595 20.7418Z"
      fill="#0A0D1B"
    />
    <path
      d="M16.3916 18.6958L16.115 18.8621C14.8824 19.603 13.4715 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.4715 19.603 14.8824 18.8621 16.115L18.6958 16.3916L18.9053 18.9053L16.3916 18.6958Z"
      fill="white"
    />
    <path
      d="M12.0003 16.9985C12.5528 16.9985 13.0007 16.5508 13.0007 15.9985C13.0007 15.4463 12.5528 14.9985 12.0003 14.9985C11.4479 14.9985 11 15.4463 11 15.9985C11 16.5508 11.4479 16.9985 12.0003 16.9985Z"
      fill="#0A0D1B"
    />
    <path
      d="M13 14H11V13C11 12.2627 11.3827 11.7005 11.9775 11.2286C12.1564 11.0867 12.2102 11.0511 12.534 10.8458C12.8225 10.6629 13 10.3473 13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10H9C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10C15 11.0396 14.4661 11.989 13.6048 12.535C13.3517 12.6954 13.3207 12.716 13.2205 12.7955C13.0563 12.9257 13 13.0084 13 13V14Z"
      fill="#0A0D1B"
    />
  </svg>
);
